import React, { Fragment, Component } from "react";
import { withFormik, Field } from "formik";
import SubmitButton from "../SubmitButton";
import { FORM_ERRORS } from "../../../texts";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as LoadingActions } from "../../../store/ducks/loading";
import { Creators as UsuariosActions } from "../../../store/ducks/usuarios";
import { Creators as ModalActions } from "../../../store/ducks/modal";
import { Creators as ErrorActions } from "../../../store/ducks/error";
import { Creators as SuccessActions } from "../../../store/ducks/success";
import api from "../../../services/api";

export class Form extends Component {
  render() {
    const props = this.props;
    return (
      <Fragment>
        <form onSubmit={props.handleSubmit}>
          <div className="label-grid">
            <label
              className={
                !!props.errors.current_password &&
                props.touched.current_password
                  ? "error"
                  : ""
              }
            >
              Senha atual
              <Field
                type="password"
                name="current_password"
                className="name"
                disabled={props.action === "DETAIL"}
              />
              <span>
                {props.errors.current_password && props.errors.current_password}
              </span>
            </label>
          </div>
          <div className="label-grid">
            <label
              className={
                !!props.errors.password && props.touched.password ? "error" : ""
              }
            >
              Nova senha
              <Field
                type="password"
                name="password"
                className="name"
                disabled={props.action === "DETAIL"}
              />
              <span>{props.errors.password && props.errors.password}</span>
            </label>
          </div>
          <div className="label-grid">
            <label
              className={
                !!props.errors.password_confirmation &&
                props.touched.password_confirmation
                  ? "error"
                  : ""
              }
            >
              Confirme a nova senha
              <Field
                type="password"
                name="password_confirmation"
                className="name"
                disabled={props.action === "DETAIL"}
              />
              <span>
                {props.errors.password_confirmation &&
                  props.errors.password_confirmation}
              </span>
            </label>
          </div>
          <SubmitButton disabled={props.loading}>Alterar senha</SubmitButton>
        </form>
      </Fragment>
    );
  }
}

const UsuariosForm = withFormik({
  mapPropsToValues: props => ({
    current_password: "",
    password: "",
    password_confirmation: ""
  }),
  validateOnChange: true,
  validateOnBlur: false,
  validate: values => {
    const errors = {};
    if (!values.current_password) {
      errors.current_password = FORM_ERRORS.REQUIRED;
    }
    if (!values.password) {
      errors.password = FORM_ERRORS.REQUIRED;
    }
    if (!values.password_confirmation) {
      errors.password_confirmation = FORM_ERRORS.REQUIRED;
    }
    return errors;
  },
  handleSubmit: (values, { props, setSubmitting, setErrors }) => {
    props.setLoading();
    const current_password = values.current_password;
    const password = values.password;
    const password_confirmation = values.password_confirmation;
    api
      .put(`/authenticated/user/password`, {
        current_password,
        password,
        password_confirmation
      })
      .then(data => {
        props.unsetLoading();
        props.openSuccess("Senha alterada com sucesso.");
        props.closeModalSenha();
      })
      .catch(err => {
        props.unsetLoading();
        if (err.response.data) {
          if (err.response.data.error) {
            let message = err.response.data.error.message;
            let erros = "";
            if (
              err.response.data.error.errors &&
              err.response.data.error.errors.length > 0
            ) {
              erros = err.response.data.error.errors
                .map(err => `${err} <br/>`)
                .join("");
            }
            props.openError(`${message}<br/>${erros}`);
          } else {
            props.openError("Ocorreu um erro não identificado.");
          }
        } else {
          props.openError("Ocorreu um erro não identificado.");
        }
        console.log(err);
      });
  }
})(Form);

const mapStateToProps = state => ({
  usuarios: state.usuarios,
  loading: state.loading.loading
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...UsuariosActions,
      ...ModalActions,
      ...LoadingActions,
      ...ErrorActions,
      ...SuccessActions
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsuariosForm);



// WEBPACK FOOTER //
// ./src/components/Forms/Usuarios/senha.js